var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"naowrap"}},[_c('div',{ref:"sceneContainer",staticClass:"naoscene",attrs:{"id":"scene-container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }